const appEnv = {
  PUB_MODE: "v3-prod",
  PUB_API_GATEWAY_ENDPOINT_OPERATION: "https://api.emergency-assesment.publicserviceplatform.com/ope/v3",
  PUB_API_GATEWAY_ENDPOINT_COMMON: "https://api.emergency-assesment.publicserviceplatform.com/cmn/v3",
  PUB_API_GATEWAY_ENDPOINT_EMERGENCY: "https://api.emergency-assesment.publicserviceplatform.com/ema/v3",
  PUB_AUTH_ENDPOINT: "https://api.emergency-assesment.publicserviceplatform.com/auth/v3",
  PUB_IDENTITY_POOL_ID: "ap-northeast-1:33a5692a-8f14-453a-87c4-b299c054f128",
  PUB_USER_POOL_ID: "ap-northeast-1_PKSJmt0X9",
  PUB_CLIENT_ID: "1t4f48hno7ggriufb1h1ioojl",
  PUB_CONTENTS_BUCKET: "disaster-emergency-contents-v3-prod",
  PUB_S3_BUCKET_ENDPOINT: null,
  PUB_AUTHORIZATION_AUTH_ENDPOINT: null,
  PUB_PEPPER_KEY_OF_CIPHER: "ThisIsCipherKey",
  PUB_MFA_ENABLE: false
};

export default appEnv;
